export default __webpack_public_path__ + "static/media/trash.79a53fce.svg";